import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';

const gravitySearchFilterBarCss = ".search-filter-bar{border-bottom:1px solid rgba(0, 15, 30, 0.05);box-sizing:border-box;display:flex;height:40px;overflow:auto hidden;padding:0 16px}.search-filter-bar:hover,.search-filter-bar:focus-within{border-bottom-color:rgba(0, 15, 30, 0.2)}.search-filter-bar .search{flex:1;overflow:hidden}.search-filter-bar .filter{align-items:center;border-left:1px solid rgba(0, 15, 30, 0.05);display:flex;height:20px;padding:10px 32px;white-space:nowrap}.search-filter-bar .filter--hidden{display:none}";
const GravitySearchFilterBarStyle0 = gravitySearchFilterBarCss;

const GravitySearchFilterBar = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.clear = createEvent(this, "clear", 7);
        this.searchChange = createEvent(this, "searchChange", 7);
        this.placeholder = 'Search';
        this.value = '';
        this.showSlot = false;
    }
    /**
     * Focuses the input field
     */
    async inputFocus() {
        const input = this.element.shadowRoot.querySelector('gravity-search');
        return input.inputFocus();
    }
    handleChange($event) {
        $event.stopPropagation();
        this.searchChange.emit($event.detail);
    }
    handleSlotChange() {
        this.showSlot = !!this.element.childNodes.length;
    }
    render() {
        return (h("div", { key: '0750d3a456a1d7342530ebcd3d788a60e51eeed2', class: "search-filter-bar" }, h("gravity-search", { key: '24f525124ccd44d02ba8ce1448ecab1313ea6421', class: "search", value: this.value, placeholder: this.placeholder, size: "medium", onSearchChange: ($event) => this.handleChange($event), type: "search-bar" }), h("div", { key: '271a98484da0e2400671a7d9c6d015bafd54b6af', class: `filter filter--${this.showSlot ? 'visible' : 'hidden'}` }, h("slot", { key: 'ab1cb4529d6f608da0bb4837acb54b4cb3986676', onSlotchange: () => this.handleSlotChange() }))));
    }
    get element() { return getElement(this); }
};
GravitySearchFilterBar.style = GravitySearchFilterBarStyle0;

export { GravitySearchFilterBar as gravity_search_filter_bar };

//# sourceMappingURL=gravity-search-filter-bar.entry.js.map